<template>
    <div>
        <v-container fluid :style="{ 'min-height': '800px' }">
            <v-container class="contain-width">

                <v-row>
                    <v-col
                            cols="12"
                        md="8"
                        offset-md="2"
                        lg="6"
                        offset-lg="3"
                            class="login-form"
                    >
                        <h1 class="mt-6 mb-6">{{ $t('headings.Nominate an organisation') }}</h1>
                        <v-card
                                class="mx-auto form-card"
                                outlined
                        >

                            <div v-if="nominated == true">
                                <p class="headline">{{ $t("Nomination sent, thank you") }}</p>
                                <v-btn rounded  elevation="0" color="primary" @click="nominated = false">{{ $t('buttons.Send another') }}</v-btn>
                            </div>

                            <v-card-text v-else class="text--primary">
                                <p class="body-1">{{ $t("If you have seen or heard of the {brand} lost property system, and would like us to contact a Club, School, College or any organisation that you think might benefit from our service, please fill out the form below and submit your nomination", {brand: brandName}) }}. {{ $t("We will contact them, and send over all the information needed to sign up free of charge and start solving any lost property issues") }}.</p>
                                <ValidationObserver ref="observer">
                                    <v-form v-model="valid" @submit.prevent="handleSubmit">

                                        <ValidationProvider vid="organisationName" name="Organisation name" rules="required" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="organisationName"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Organisation name')"
                                                    required
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="contactName" name="Contact name" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="contactName"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Contact name')"
                                                    hint="If known"
                                                    persistent-hint
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="contactPhone" name="Contact phone" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="contactPhone"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Contact phone')"
                                                    :hint="$t('hints.If known')"
                                                    persistent-hint
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="Contact email" name="Contact email" rules="email" v-slot="{ errors }">
                                            <v-text-field
                                                    v-model="contactEmail"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Contact email')"
                                                    :hint="$t('hints.If known')"
                                                    persistent-hint
                                            ></v-text-field>
                                        </ValidationProvider>

                                        <ValidationProvider vid="message" name="Message" v-slot="{ errors }">
                                            <v-textarea
                                                    v-model="message"
                                                    :error-messages="errors[0]"
                                                    :label="$t('labels.Additional information')"
                                                    :hint="$t('hints.Such as reason why you are nominating')"
                                                    persistent-hint
                                            ></v-textarea>
                                        </ValidationProvider>

                                        <vue-programmatic-invisible-google-recaptcha
                                                ref="invisibleRecaptcha1"
                                                :sitekey="'6Lc1or0UAAAAAHToK0_wzBIEmJSp2BHGNh35DzKL'"
                                                :elementId="'invisibleRecaptcha1'"
                                                :badgePosition="'left'"
                                                :showBadgeMobile="false"
                                                :showBadgeDesktop="true"
                                                @recaptcha-callback="recaptchaCallback"
                                        ></vue-programmatic-invisible-google-recaptcha>

                                        <div class="d-flex justify-end">
                                            <v-btn v-if="recaptchaFailed" @click="resetRecaptcha" color="error">reCAPTCHA failed: reset</v-btn>

                                            <v-btn class="small" rounded elevation="0" color="primary" @click="handleSubmit">{{ $t('buttons.Submit') }}</v-btn>
                                        </div>
                                    </v-form>
                                </ValidationObserver>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-container>
        <Footer />
    </div>
</template>

<script>

    import {nominateService} from "../services/nominate-service";
    import { store } from '../store';
    import { extend } from 'vee-validate';
    import { required, email } from 'vee-validate/dist/rules';

    import Footer from './Footer.vue'
    import {i18n} from "../i18n";
    import {mapState} from "vuex";

    // Add the required rule
    extend('required', required);

    // Add the email rule
    extend('email', email);

    export default {
        name: "Nominate",
        metaInfo() {
          return {
            title: this.capitalizeFirstLetter(this.brand) + ' - ' + i18n.t('Nominate'),
            htmlAttrs: {
              lang: i18n.locale
            }
          }
        },
        components: {
            'Footer': Footer
        },
        data: () => ({
            organisationName: '',
            contactName: '',
            contactPhone: '',
            contactEmail: '',
            message: '',
            submitted: false,
            nominated: false,
            valid: false,
            recaptchaFailed: false
        }),
        mounted () {

            window.scrollTo(0,0);

            window.prerenderReady = true;
        },
        computed: {
          ...mapState({
            brand: state => state.brand,
            brandName: state => state.brandName
          }),
          getBackground() {
            if (this.brand === 'neotag') {
              return require('@/assets/neotag-background.jpg')
            }
            else {
              return require('@/assets/neotag-background.jpg')
            }
          },
        },
        methods: {
            capitalizeFirstLetter(string) {
              return string.charAt(0).toUpperCase() + string.slice(1);
            },
            async handleSubmit () {

                this.submitted = true;

                let observer = this.$refs.observer;

                const isValid = await observer.validate();

                if (isValid) {
                    this.$refs.invisibleRecaptcha1.execute()

                }

            },
            recaptchaCallback (recaptchaToken) {

                const { organisationName, contactName, contactPhone, contactEmail, message } = this;

                let brandSlug = this.brand.slug
                if (organisationName && recaptchaToken) {

                    nominateService.nominate(organisationName, contactName, contactPhone, contactEmail, message, recaptchaToken, brandSlug).then(response => {
                        console.log(response)
                        this.nominated = true;
                        this.organisationName = ''
                        this.contactName = ''
                        this.contactPhone = ''
                        this.contactEmail = ''
                        this.message = ''

                        window.scrollTo(0,0);

                    }).catch(function (error) {
                        console.log(error)

                        // Add the server side errors for each field.
                        this.$refs.observer.setErrors(store.getters.validationErrors);

                        if (store.getters.validationErrors['recaptchaToken']) {
                            this.recaptchaFailed = true;
                        }
                    });
                }
            },
            resetRecaptcha () {
                this.$refs.invisibleRecaptcha1.reset()
                this.recaptchaFailed = false;
            }
        }
    }
</script>

<style scoped>
    button {
        text-transform: none;
    }
    .product-card {
        border-radius: 15px 15px 0 0;
        border: none !important;
    }
</style>
